import { render, staticRenderFns } from "./AdministratorsList.vue?vue&type=template&id=ed2ef698&scoped=true&"
import script from "./AdministratorsList.vue?vue&type=script&lang=js&"
export * from "./AdministratorsList.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorsList.vue?vue&type=style&index=0&id=ed2ef698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2ef698",
  null
  
)

export default component.exports